//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../../../axios/axios.js'
import DeleteBrigadeActiveRequests from './DeleteBrigadeActiveRequests.vue'

export default {
  props: {
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    date: {
      type: Date,
      default: null
    }
  },
  data: function () {
    return {
      loading: false
    }
  },
  methods: {
    onCloseDeleteBrigade: function () {
      this.$emit('close')
    },
    onSaveDeleteBrigade: function () {
      this.loading = true
      axiosGet({
        url: '/service/delta/brigade/disband?id=' + this.brigade.id + '&workDate=' + this.date.getTime() + (this.brigade.workShift ? '&workShift=' + this.brigade.workShift.key : ''),
        onSuccess: () => {
          let employeesIds = []
          if (this.brigade.employees && this.brigade.employees.length) {
            employeesIds = this.brigade.employees.map((employee) => employee.id)
          }

          this.$emit('update', { brigades: { ids: [this.brigade.id], operation: 'delete' }, employees: { ids: employeesIds } })
          this.$q.notify({
            type: 'negative',
            message: 'Бригада "' + this.brigade.name + '" расформирована',
            progress: true,
            timeout: 8000
          })
        },
        onFailure: (response) => {
          if (response && response.requests && response.requests.length) {
            const dialog = this.$d.dialog(this).show({
              maximizedOnNarrow: true,
              persistent: true,
              noWrap: true,
              contentWidth: 560,
              contentComponent: DeleteBrigadeActiveRequests,
              contentProps: {
                requests: response.requests,
                brigade: this.brigade,
                date: this.date
              },
              componentHandlers: {
                update: (data) => {
                  this.$emit('update', data)
                  dialog.hide()
                },
                close: () => {
                  dialog.hide()
                  this.$emit('close')
                }
              }
            })
          } else {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })
          }
        },
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

